export default __webpack_public_path__ + "static/us_consumer_ac_hero_smilephone-70f59b97d315890f60efded3e79b6d78.jpeg";